// Atomを管理するキー
export enum AtomKeys {
  QUIZ_CONTENT_STATE = 'quizContentState',
  QUIZ_RESPONDENT_STATE = 'quizRespondentState',
  DIAGNOSIS_CONTENT_STATE = 'diagnosisContentState',
  DIAGNOSIS_RESPONDENT_STATE = 'diagnosisRespondentState',
}

// Selectorを管理するキー
export enum SelectorKeys {}
